module.exports = __webpack_public_path__ + "img/step1_en-GB.dbc1fb41.png";